import { EmptyState, FlexBox } from '@airship-platform/jam-web/components';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router';
import { useAccountManagement } from './contexts/AccountManagementContext';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { confirmAccount, error, isLoading } = useAccountManagement();

  const token = searchParams.get('token');
  const email = searchParams.get('email');

  useEffect(() => {
    token && confirmAccount(token);
  }, [confirmAccount, token]);

  if (!token) {
    return (
      <EmptyState
        title="Invalid or missing token"
        subtitle="Please check your reset password link and try again."
      />
    );
  }

  return (
    <FlexBox
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      textAlign={'center'}
      minHeight={'100vh'}
      maxWidth={'25rem'}
      gap={4}
    >
      {isLoading ? (
        <FlexBox flexDirection={'column'} alignItems={'center'} gap={2}>
          <CircularProgress color="primary" />
          <Typography variant="body1">Verifying email...</Typography>
        </FlexBox>
      ) : error ? (
        <Typography variant="body1">
          Failed to verify email. You may have already verified your email or
          your link has expired.
        </Typography>
      ) : (
        <Typography variant="body1">
          Your email <strong>{email}</strong> has been successfully verified!
        </Typography>
      )}
      <Button component={Link} to="/signin">
        {error ? 'Go to Sign In' : 'Sign In'}
      </Button>
    </FlexBox>
  );
};

export default VerifyEmail;
